import React from 'react';

import JobDescriptionsFromExternalWebsitesLoader from './JobDescriptionsFromExternalWebsitesLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import JobDescriptionsFromExternalWebsitesTable from './JobDescriptionsFromExternalWebsitesTable';
import JobDescriptionsFromExternalWebsitesPageController from './JobDescriptionsFromExternalWebsitesPageController';
import UpdateJobDescriptionFromExternalWebsiteModal from './UpdateJobDescriptionFromExternalWebsiteModal';
import CloseJobDescriptionFromExternalWebsiteModal from './CloseJobDescriptionFromExternalWebsiteModal';
import ReopenJobDescriptionFromExternalWebsiteModal from './ReopenJobDescriptionFromExternalWebsiteModal';
import DeleteJobDescriptionFromExternalWebsiteModal from './DeleteJobDescriptionFromExternalWebsiteModal';
import ArchiveJobDescriptionFromExternalWebsiteModal from './ArchiveJobDescriptionFromExternalWebsiteModal';
import { useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';
import { scheduleLineImportanceAnalysis, scheduleCloseStaleJobDescriptions } from '../../JobProspectsStats/components/restApi';
import { deleteJobDescriptionsWithBlockedTitles } from './restApi';

import styles from './JobDescriptionsFromExternalWebsites.module.scss';

const JobDescriptionsFromExternalWebsites = () => {
  const { onResponse, onError } = useJobDescriptionsFromExternalWebsitesActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleScheduleLineImportance = () => {
    scheduleLineImportanceAnalysis({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  const handleCloseStaleJobDescriptions = () => {
    scheduleCloseStaleJobDescriptions({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  const handleDeleteJobDescriptionsWithBlockedTitles = () => {
    deleteJobDescriptionsWithBlockedTitles({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <>
      <JobDescriptionsFromExternalWebsitesLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Job Descriptions from External Websites'} />
          <ActionRow>
            <Button onClick={handleScheduleLineImportance}>
              Schedule Line Importance Analysis
            </Button>
            <Button onClick={handleCloseStaleJobDescriptions}>
              Close Stale Job Descriptions
            </Button>
            <Button onClick={handleDeleteJobDescriptionsWithBlockedTitles}>
              Delete Job Descriptions With Blocked Titles
            </Button>
          </ActionRow>
          <JobDescriptionsFromExternalWebsitesTable />
          <JobDescriptionsFromExternalWebsitesPageController />
        </Stack>
      </div>
      <UpdateJobDescriptionFromExternalWebsiteModal />
      <CloseJobDescriptionFromExternalWebsiteModal />
      <ReopenJobDescriptionFromExternalWebsiteModal />
      <DeleteJobDescriptionFromExternalWebsiteModal />
      <ArchiveJobDescriptionFromExternalWebsiteModal />
    </>
  );
};

export default JobDescriptionsFromExternalWebsites;